import { Localizable } from '@components/localizable/Localizable'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { requiredRule } from '@utils/rules'
import { Form } from 'antd'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  return (
    <Form {...formProps} form={form} layout="vertical">
      <Localizable.Input name={'title'} label={'Title'} max={60} />

      <Localizable.TextEditor
        name={'body'}
        label={'Content'}
        rules={[requiredRule()]}
        mode="full"
      />
    </Form>
  )
}

export default Create
